/**
 * ENG-4033 — which Protected model the backend is on (ENG-4027, docs/CATALOG_GLOSSARY.md §3.4).
 *
 * - `1`, the old model: a site pauses extensions when it is in the subject's protected set (enabled
 *   categories, opt-outs, locks, custom sites) AND is shielded (one of Haven's five default
 *   categories, or a category or site the organization added). A lock or an added category on a row
 *   outside that set reaches nothing.
 * - `2`, the one-set model (§3.3): a site is Protected when it is locked, added, a custom site, or in
 *   an enabled category and not opted out. Every catalog site is Verified, whatever anyone sets.
 *
 * The backend sends it on `/subscription-status` (`protectedModel`) and on effective-protection
 * (`sites.protectedModel`). It is one global switch, `site_config` `eng4027.protected-model`, flipped
 * by a staff migration after the extension that knows both rules (ENG-4052) reaches the fleet. Until
 * then, and whenever it is missing or unreadable, it is 1, so the console must be right under both.
 *
 * ENG-4044: remove model-1 branch after the flip — every `protectedModel === 1` branch in the console
 * is marked with that line.
 */
export type ProtectedModel = 1 | 2;

/** The model a wire value names. Anything but 2 is the old model, as on the server. */
export const protectedModelOf = (value: unknown): ProtectedModel => (value === 2 ? 2 : 1);
